import type { IOrganizationFeatureBasiq } from './OrganizationFeatureBasiq.interface';

export default class OrganizationFeatureBasiq implements IOrganizationFeatureBasiq {
  basiqRemaining: number;
  automaticallyRecharge: boolean;
  rechargeWhenBasiqRemainingReach: number;

  static build = (data: IOrganizationFeatureBasiq) => new OrganizationFeatureBasiq(data);
  static blank = () => new OrganizationFeatureBasiq();

  /**
   * Constructor
   * @param {IOrganizationFeatureBasiq} data
   */
  constructor(data?: IOrganizationFeatureBasiq) {
    this.basiqRemaining = parseInt(data?.basiqRemaining || 0, 10);
    this.automaticallyRecharge = data?.automaticallyRecharge === true;
    this.rechargeWhenBasiqRemainingReach = parseInt(
      data?.rechargeWhenBasiqRemainingReach || 0,
      10
    );
  }
}
